
const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1)

const uncapitalize = str => str.charAt(0).toLowerCase() + str.slice(1);

const dasherize = str => str.replace(/([A-Z])/g, (_, char) => `-${char.toLowerCase()}`)

const unDasherize = str => str.split('-').map(subStr => capitalize(subStr)).join('');

const domReady = () => {
  return new Promise(resolve => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', resolve)
    } else {
      resolve()
    }
  })
}

const getElement = (selector, { context = document } = {}) => context.querySelector(selector);

const getElements = (selector, { context = document} = {}) => {
  const items = context.querySelectorAll(selector);
  return Array.from(items);
}

const productCard = ( cardEl ) => {
  const variants = getElements('.variant_color', {context: cardEl});
  const mediaEl = getElement('.product_media', {context: cardEl});
  variants.forEach(variant => {
    if(getElement('.v_featured_image', {context:variant})) {
      getElement('.v_featured_image', {context:variant}).setAttribute('src', getElement('.v_featured_image', {context:variant}).dataset.src);
    }
    let event = /iPhone|iPad|iPod|Android|Windows Phone/.test(navigator.userAgent) ? 'click' : 'mouseover';
    variant.addEventListener(event, () => {
      //mediaEl.setAttribute('href', variant.href); not working properly, href undefined.
      const featuredURL = variant.dataset['variant_url'];
      mediaEl.setAttribute('href', featuredURL);
      const featuredImage = variant.dataset['featured_image'];
      featuredImage ? mediaEl.style.backgroundImage = `url(${featuredImage})` : mediaEl.style.backgroundImage = `url(${mediaEl.dataset['featured_image']})`;
      $(variants).removeClass('active_variant');
      variant.classList.add('active_variant');
    })
  })
}